import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {UncountedStockReportModel} from "./uncounted-stock-report.model";

@Component({
    selector: "wbo-uncounted-stock-report",
    templateUrl: "./uncounted-stock-report.component.html",
    providers: [provideReportModel(UncountedStockReportModel)]
})
export class UncountedStockReportComponent extends AbstractReportPage {
    constructor(public model: UncountedStockReportModel) {
        super();
    }
}
